var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.$store.state.platform == 'pc')?[_c('Header'),_c('div',{staticStyle:{"height":"134px"}}),_c('BreadCrumb'),_c('router-view'),_c('Footer')]:[_c('HeaderMob'),_c('div',{staticStyle:{"height":"55px"}}),_c('transition',{attrs:{"name":_vm.transitionName}},[_c('router-view')],1),_c('FooterMob')]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }